import Vue from "vue";

import ContentChildrenMenu from "./ContentChildrenMenu.vue";

export function load(payload) {
    const selector = "content-children-menu";
    const store = payload;
    // Is the custom Vue root element in the DOM?
    if (!document.querySelector(selector)) {
        return;
    }

    // Create a new Vue app with the imported Home component
    new Vue({
        store,
        render: createElement =>
            createElement(ContentChildrenMenu, {
                props: {
                    ...window[selector],
                },
            }),
    }).$mount(selector);
}